<div class="h-100 w-100 dark-bg">
    <!-- Begin page content -->
    <main class="container-fluid h-100 auth-layout">
        <router-outlet></router-outlet>
    </main>
    <!-- Page content ends-->
</div>